import {request} from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
    return request<{
        data: API.CurrentUser;
    }>('/etmf/v1/sys/user/current', {
        method: 'GET',
        ...(options || {}),
    });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams) {
    return request<API.Result<API.CurrentUser>>('/etmf/v1/sys/user/login_user', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/form',
        },
        params: body,
    });
}

export async function userList(params: any) {
    return request<API.Page<API.User>>('/etmf/v1/sys/user/page', {
        params,
    });
}

export async function getRelatedUserList(params: API.PageParams & { roleId?: string, positionId?: string, }) {
    let url = '/etmf/v1/sys/position/list_users_by_position_id';
    if (params.roleId) {
        url = '/etmf/v1/sys/func/users_by_rid_list';
    }
    return request<API.Page<API.User>>(url, {
        method: 'POST',
        params,
    });
}

// 修改密码
export async function editPassword(data:any) {
    return request<API.Result<API.User>>("/etmf/v1/sys/user/edit/password", {
        method: "POST",
        data,
    });
}
